import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { useChats } from 'shared/hooks/useChats';
import { useRenderContactButtons } from 'shared/hooks/useRenderContactButtons';
import { selectOffer, selectUser } from 'shared/selectors';
import { selectEarlyAccessContactsFlowEnabled } from 'shared/selectors/earlyAccess/selectEarlyAccessContactsFlowEnabled';
import { getAgent } from 'shared/selectors/newObject/getAgent';

import { useEarlyAccessPaywallContext } from '../../../packages/EarlyAccessPaywall';
import {
  EAccessCheckTrackingStatus,
  EStatus,
  ESubscriptionLimitType,
} from '../../../packages/EarlyAccessPaywall/shared/types/context';
import { offerChatSelector } from '../../selectors/offerChat';
import { trackBlockedEarlyAccessChatClick } from '../../utils/tracking/earlyAccessTracking';
import { trackSendMessageClick } from '../ChatPopupContainer/tracking';

export const AuthorSendMessageContainer = () => {
  const offerChat = useSelector(offerChatSelector);
  const { showChatButton } = useRenderContactButtons();
  const { telemetry } = useApplicationContext();
  const { handleOpenChat } = useChats();
  const offer = useSelector(selectOffer);
  const agent = useSelector(getAgent);
  const user = useSelector(selectUser);
  const { checkContactsAccess, status } = useEarlyAccessPaywallContext();
  const isEarlyAccessContactsFlowEnabled = useSelector(selectEarlyAccessContactsFlowEnabled);

  const renderChat = offerChat && offerChat.isChatsEnabled && showChatButton;

  const handleEarlyAccessFlow = React.useCallback(async () => {
    if (!user?.isAuthenticated) {
      trackBlockedEarlyAccessChatClick({
        offer,
        agent,
        blockType: EAccessCheckTrackingStatus.Unauthorized,
      });
    }

    const { isConfirmed, trackingStatus } = await checkContactsAccess({
      offerId: offer.id,
      limitType: ESubscriptionLimitType.Chat,
    });

    if (isConfirmed) {
      telemetry.increment('offer_card.send_message_click.author.early_access');
      trackSendMessageClick({ offer, agent, isEarlyAccess: true });
      handleOpenChat({ isEarlyAccess: true });

      return;
    }

    if (trackingStatus) {
      trackBlockedEarlyAccessChatClick({
        offer,
        agent,
        blockType: trackingStatus,
      });
    }
  }, [user?.isAuthenticated, checkContactsAccess, offer, agent, telemetry, handleOpenChat]);

  const handleSendMessageClick = React.useCallback(async () => {
    if (isEarlyAccessContactsFlowEnabled) {
      await handleEarlyAccessFlow();

      return;
    }

    telemetry.increment('offer_card.send_message_click.author');
    handleOpenChat();
  }, [isEarlyAccessContactsFlowEnabled, telemetry, handleOpenChat, handleEarlyAccessFlow]);

  if (!renderChat) {
    return null;
  }

  return (
    <Button size="XS" theme="fill_secondary" onClick={handleSendMessageClick} loading={status === EStatus.Loading}>
      Написать сообщение
    </Button>
  );
};
